import { getUrl } from '../../helpers/getUrl';
import { pushToDataLayer } from '../pushToDataLayer';

function buyNowClickOnProductDetailPage() {
  const productName = $('.ga-page-load-events').data('productname');
  $('.ga-buy-now-button').on('click', (event) => {
    const $link = $(event.currentTarget);
    pushToDataLayer({
      event: 'buy-now-button',
      label: productName
    });

    pushToDataLayer({
      event: 'gaEvent',
      eventTrigger: 'buyNowClick',
      eventCategory: 'Buy Now - Retailer Click - Retailer Domain',
      eventAction: productName,
      eventLabel: $link.data('siteurl')
    });

    pushToDataLayer({
      event: 'gaEvent',
      eventTrigger: 'buyNowClick',
      eventCategory: 'Buy Now - Retailer Click - Page URL',
      eventAction: productName,
      eventLabel: getUrl(window.location)
    });
  });
}

function productFindeoutProductSelect() {
	$('.js-product-findout').on('click', event => pushToDataLayer({
		event: 'engagement',
		action: 'findout',
		label: $(event.currentTarget).data('productname')
	}));
}

function buyNowRetailerClick() {
	$(document).on('click', '.ga-buyNow-retailerClick', event => {
		const $link = $(event.currentTarget);
		const productName = $('.ga-page-load-events').data('productname');

		pushToDataLayer({
			event: 'gaEvent',
			eventTrigger: 'buyNowClick',
			eventCategory: 'Buy Now - Retailer Click - Retailer Domain',
			eventAction: productName,
			eventLabel: $link.data('retailer-name')
		});

		pushToDataLayer({
			event: 'gaEvent',
			eventTrigger: 'buyNowClick',
			eventCategory: 'Buy Now - Retailer Click - Page URL',
			eventAction: productName,
			eventLabel: getUrl(window.location)
		});
	});
}

function buyNowClic2Buy() {
	$('.ga-click-to-buy').on('click', event => {
		pushToDataLayer({
			event: 'gaEvent',
			eventTrigger: 'buyNowClick',
			eventCategory: 'Buy Now - List Retailers',
			eventAction: $(event.currentTarget).data('productname'),
			eventLabel: getUrl(window.location)
		});
	});
}

function buyNowListRetailers() {
	$('.ga-buy-now-popup').on('click', () => {
		pushToDataLayer({
			event: 'gaEvent',
			eventTrigger: 'buyNowClick',
			eventCategory: 'Buy Now - List Retailers',
			eventAction: $('.ga-page-load-events').data('productname'),
			eventLabel: getUrl(window.location)
		});
	});
}

function whereToBuyRetailerClick() {
	$('.buyNowList a').on('click', event => {
		let targetURL = $(event.currentTarget).attr('href');

		if (targetURL !== '') {
			targetURL = targetURL.startsWith('http://') || targetURL.startsWith('https://') || targetURL.startsWith('www.')
				? targetURL : 'www.' + targetURL;
      if (targetURL.indexOf('?') > 0) {
        targetURL = targetURL.split('?')[0];
      }

			pushToDataLayer({
				event: 'gaEvent',
				eventTrigger: 'buyNowClick',
				eventCategory: 'Buy Now - Where to buy',
				eventAction: window.location.href,
				eventLabel: targetURL
			});
		}
	});
}

export const addProductListeners = () => {
	buyNowClic2Buy();
	buyNowClickOnProductDetailPage();
	buyNowListRetailers();
	buyNowRetailerClick();
	productFindeoutProductSelect();
	whereToBuyRetailerClick();
}
